import { UIState } from '../types'

import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

export const useOCRUI = defineStore('OCRUI', () => {
  const uiState = ref<UIState>(UIState.Initial)
  const latestOCRRequestId = ref<string>('')

  const isLoading = computed(() => uiState.value === UIState.Loading)

  function transitionTo(state: UIState): void {
    uiState.value = state
  }

  function setLatestOCRRequestId(id: string): void {
    latestOCRRequestId.value = id
  }

  const isProcessing = computed(() => {
    return (
      uiState.value === UIState.Loading ||
      uiState.value === UIState.WaitingForMB
    )
  })

  return {
    isLoading,
    isProcessing,
    transitionTo,
    uiState,
    latestOCRRequestId,
    setLatestOCRRequestId,
  }
})
